import { render, staticRenderFns } from "./GroupMessageActionV2.vue?vue&type=template&id=5cae2e7d&scoped=true"
import script from "./GroupMessageActionV2.vue?vue&type=script&lang=js"
export * from "./GroupMessageActionV2.vue?vue&type=script&lang=js"
import style0 from "./GroupMessageActionV2.vue?vue&type=style&index=0&id=5cae2e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae2e7d",
  null
  
)

export default component.exports